<template>
	<sf-data-table
		ref="daemonTable"
		selection
		@select="select"
		@select-all="selectAll"
		:excel="isButton_(scrId, 'EX')"
		:columns="columns"
		:rows="processes"
		:customExcel="excelFunc"
		index
		height="100%"
		paging
		:pageUnit="pageUnit_"
		:pageArray="screen.pageArray"
		:totalSize="totalSize_"
		@changedPage="changedPage"
	>
		<template v-slot:actionsLeft>
			<sf-button v-if="isButton_(scrId, 'CU')" :disabled="!isControllable" size="lg" line :onClick="() => setStatus('1')">{{
				getMessage_('SWCC000829')
			}}</sf-button>
			<sf-button v-if="isButton_(scrId, 'CU')" :disabled="!isControllable" size="lg" line color="error" :onClick="() => setStatus('0')">{{
				getMessage_('SWCC000828')
			}}</sf-button>
			<sf-button :disabled="!isNull(controlUser.userId)" :onClick="getControl">{{ getMessage_('MTCO040068') }}</sf-button>
			<sf-button v-show="isControllable" :onClick="returnControl">{{ getMessage_('MTCO040069') }}</sf-button>
		</template>
		<template v-slot:customRows="slotProps">
			<template v-if="slotProps.column.property === 'procStatus'">
				<div class="status--stop" v-if="slotProps.row.procStatus === 'stop'" />
				<div class="status--normal" v-else-if="slotProps.row.procStatus === 'normal'" />
				<div class="status--warning" v-else-if="slotProps.row.procStatus === 'warning'" />
				<div class="status--error" v-else-if="slotProps.row.procStatus === 'error'" />
			</template>
		</template>
		<template v-slot:footer>
			<div class="running-status">
				<div>
					<span>{{ getMessage_('MTCO040037') }}</span>
				</div>
				<div>
					<sf-tag color="blue">{{ getMessage_('MTCO040038') }}</sf-tag>
					<sf-tag color="yellow">{{ getMessage_('MTCO040039') }}</sf-tag>
					<sf-tag color="orange">{{ getMessage_('MTCO040040') }}</sf-tag>
					<sf-tag color="black">{{ getMessage_('MTCO040041') }}</sf-tag>
				</div>
			</div>
		</template>
	</sf-data-table>
</template>

<script>
import moment from 'moment';
import columns from './columns';
import { rootComputed, rootMethods } from '@/store/common/helpers';
import { serviceComputed, serviceMethods } from '@common/DaemonProcessManagement/store/helpers';
import { utils } from '@sfaas/util';
import { BASE_URL } from '@/constants';

export default {
	props: {
		scrId: { type: String, default: '' }
	},
	data() {
		return {
			screen: {},
			nIntervId: null,
			selectedRows: [],
			usercontrolListener: null
		};
	},
	updated() {
		const daemonTable = this.$refs.daemonTable.getTable();
		this.selectedRows.forEach(selectedRow => {
			const index = this.processes.findIndex(row => selectedRow.pgmId === row.pgmId && selectedRow.procId === row.procId);
			daemonTable.toggleRowSelection(this.processes[index]);
		});
	},
	watch: {
		screen(screen) {
			const { userLock, userId, scrId } = screen;
			// feat : userLock
			if (!this.isNull(userLock) && !this.isUndefined(userLock)) {
				if (userId === userLock.userId) {
					this.DEFAULT_ASSIGN({ key: 'isControllable', value: true });
				} else {
					this.DEFAULT_ASSIGN({ key: 'isControllable', value: false });
				}
				this.DEFAULT_ASSIGN({ key: 'controlUser', value: { ...this.controlUser, userId: userLock.userId } });
			}
			// 추후 확인필요
			// feat : socket connection
			this.usercontrolListener =
				this.usercontrolListener ?? new this.$sf_topicListener({ topic: `usercontrol/${scrId}`, onMessage: this.onMessage });
		}
	},
	computed: {
		...rootComputed,
		...serviceComputed,
		columns() {
			return columns.map(column => ({ ...column, label: this.getMessage_(column.msgKey) }));
		}
	},
	methods: {
		...rootMethods,
		...serviceMethods,
		...utils,
		getControl() {
			this.getControl_({ plantCd: this.user.plantCd, scrId: this.screen.scrId }).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		returnControl() {
			this.returnControl_({ plantCd: this.user.plantCd, scrId: this.screen.scrId }).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		clearSelectedRows() {
			this.selectedRows = [];
		},
		select(selection, row) {
			const index = this.selectedRows.findIndex(selectedRow => selectedRow.pgmId === row.pgmId && selectedRow.procId === row.procId);
			if (index === -1) {
				this.selectedRows.push(row);
			} else {
				this.selectedRows.splice(index, 1);
			}
		},
		selectAll(selection) {
			this.selectedRows = selection.slice();
		},
		excelFunc() {
			const url = `${BASE_URL}/daemon/v1/plants/${this.user.plantCd}/processes`;
			const params = { url, columns: this.columns };
			this.xlsxDown(params).catch(error => {
				this.$sf_toast({ type: 'error', message: error.message });
			});
		},
		changedPage({ currentPageVal, pageUnitVal }) {
			Promise.resolve()
				.then(() =>
					this.DEFAULT_ASSIGN({ key: 'pagingInfo', value: { ...this.pagingInfo, currentPage: currentPageVal, pageUnit: pageUnitVal } })
				)
				.then(this.findAllProcesses);
		},
		findAllProcesses() {
			this.fetchProcesses_({ plantCd: this.user.plantCd, urlSearchParams: this.urlSearchParams_ });
		},
		setStatus(runStatus) {
			const selectedRows = this.$refs.daemonTable.getSelectedRows();
			const plantCd = this.user.plantCd;
			this.$sf_toggleLoading(true);
			Promise.resolve()
				.then(() => {
					selectedRows.forEach(daemon => {
						const { pgmUrl } = daemon;
						if (!this.isNull(pgmUrl) && !this.isUndefined(pgmUrl)) {
							this.setStatus_({ plantCd, runStatus, pgmUrl, daemon: { ...daemon, cts: runStatus } })
								.then(header => {
									this.$sf_toast({
										...this.$sf_setToastOption(header),
										message: this.getMessage_(header.messageCd) !== '' ? this.getMessage_(header.messageCd) : header.message
									});
								})
								.catch(error => {
									this.$sf_toast({ type: 'error', message: error.message });
								});
						}
					});
				})
				.then(this.clearSelectedRows)
				.finally(() => this.$sf_toggleLoading(false));
		},
		onMessage(payload) {
			if (this.screen.userId === payload.controlUser.userId) {
				this.DEFAULT_ASSIGN({ key: 'isControllable', value: true });
				this.$sf_toast({ type: 'ok', position: 'top-left', message: payload.message });
			} else {
				this.DEFAULT_ASSIGN({ key: 'isControllable', value: false });
				this.$sf_toast({ type: 'ok', position: 'top-left', message: payload.message });
			}
			this.DEFAULT_ASSIGN({ key: 'controlUser', value: payload.controlUser });
		}
	},
	created() {
		this.screen = this.screenArray.get(this.scrId);
		this.nIntervId = setInterval(this.findAllProcesses, 1000);
	},
	mounted() {
		this.$nextTick(this.wsConnect);
	},
	beforeDestroy() {
		clearInterval(this.nIntervId);
	}
};
</script>

<style lang="scss" scoped>
// TODO:
$status_normal: #1876e1;
$status_error: #e14f22;
$status_warning: #b2884a;
$status_stop: #343943;
@mixin running-status($background-color) {
	width: 10px;
	height: 10px;
	float: left;
	margin: 7px 5px 0 0;
	border-radius: 50%;
	background-color: $background-color;
}
.status {
	&--normal {
		@include running-status($status_normal);
	}
	&--warning {
		@include running-status($status_warning);
	}
	&--error {
		@include running-status($status_error);
	}
	&--stop {
		@include running-status($status_stop);
	}
}
.sf-datatable-footer {
	padding: 0 15px;
	.running-status {
		display: flex;
		justify-content: center;
		align-items: center;
	}
}
</style>
